module.exports = __webpack_public_path__ + "img/ring_r_0_0_1@2x.17f100ca.png";